var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"value":_vm.$store.state.locale,"placeholder":""},on:{"change":_vm.setLocale}},_vm._l((_vm.translations),function(ref){
var code = ref.code;
var name = ref.name;
return _c('el-option',{key:code,attrs:{"label":name,"value":code,"selected":_vm.isLocale(code)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }